import { render, staticRenderFns } from "./ResButton.vue?vue&type=template&id=0962b804&scoped=true"
import script from "./ResButton.vue?vue&type=script&lang=js"
export * from "./ResButton.vue?vue&type=script&lang=js"
import style0 from "./ResButton.vue?vue&type=style&index=0&id=0962b804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0962b804",
  null
  
)

export default component.exports